// extracted by mini-css-extract-plugin
export var fadeInOut = "_3t-3";
export var icon = "_3t-4";
export var savedIndicator = "_3t-2";
export var savingIndicator = "_3t-0";
export var spin = "_3t-1";